var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-communication",
    {
      staticClass: "eu-pa_2 emd-communication",
      class: { _fixed: _vm.fixed },
      attrs: { color: "pagarme" },
    },
    [
      _c("span", { staticClass: "emd-text _color_default eu-mt_1" }, [
        _c("span", { staticClass: "emd-pagarme-icon-outline _active" }, [
          _c(
            "span",
            [_c("emd-pagarme-icon", { attrs: { fillColor: "white" } })],
            1
          ),
        ]),
      ]),
      _c("span", { staticClass: "emd-text _type_bold eu-ml_3" }, [
        _vm._v("A Mundipagg agora é Pagar.me, "),
        _c(
          "a",
          {
            staticClass: "emd-text emd-link _color_clear _decoration_underline",
            attrs: {
              href: "https://mundipagg.zendesk.com/hc/pt-br/categories/4404432249876-Incorpora%C3%A7%C3%A3o-Mundipagg-pelo-Pagar-me",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v("acesse o nosso FAQ")]
        ),
        _vm._v(" e entenda o que muda."),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }